import { Project, ProjectOptions } from '../../types/project';
import { GetClassicCoverOptions } from '../../utils/cover/coverHelper';
import { GetProjectDisplayPage } from '../../utils/projectHelper';

export const GetProjectOptions = (project: Project): ProjectOptions => {
  if (!project) return null;

  return {
    // common
    docID: project.docID,
    type: project.type,
    numPages: GetProjectDisplayPage(project),
    coated: project.coated,
    matte: project.matte,

    // album
    paper: project.paper,
    pageNumber: project.pageNumber,
    pageNumberColor: project.pageNumberColor,
    pagePaperQuality: project.pagePaperQuality,
    cover_matte: project.cover_matte,
    flyleaf: project.flyleaf,
    coverType: project.coverType,
    coverClassicOptions: GetClassicCoverOptions(project),

    // calendar only
    startYear: project.startYear,
    startMonth: project.startMonth,
    startDay: project.startDay,
    calendarColorOptions: project.calendarColorOptions,

    // card only
    cardPack: project.cardPack,
    envelope: project.envelope,

    // canvas  only
    canvasFrameColor: project.canvasFrameColor,
    canvasFormat: project.canvasFormat,
    width: project.width,
    height: project.height,
  };
};
